import type { FC } from 'react';
import { Box, Divider, Paper, Skeleton } from '@mui/material';
import getSkeletonArray from 'utils/getSkeletonArray';

const TrendsListSkeleton: FC = () => {
  const items = getSkeletonArray(6);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(420px, 1fr))',
        gap: 2,
      }}
    >
      {items.map(({ id }) => (
        <Paper
          key={id}
          elevation={1}
          sx={{
            p: 2.5,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            backgroundColor: '#fff',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Skeleton width={96} height={18} />
            <Skeleton width={72} height={18} />
          </Box>

          <Skeleton width="90%" height={28} />
          <Skeleton width="100%" height={18} />
          <Skeleton width="95%" height={18} />
          <Skeleton width="70%" height={18} />

          <Box sx={{ display: 'flex', gap: 0.5, mt: 0.5 }}>
            <Skeleton variant="rounded" width={64} height={18} />
            <Skeleton variant="rounded" width={72} height={18} />
          </Box>

          <Divider sx={{ my: 0.5 }} />

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Skeleton width={88} height={18} />
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Skeleton width={36} height={18} />
              <Skeleton width={36} height={18} />
              <Skeleton width={36} height={18} />
            </Box>
          </Box>

          <Skeleton variant="rounded" width={120} height={30} sx={{ mt: 0.5 }} />
        </Paper>
      ))}
    </Box>
  );
};

export default TrendsListSkeleton;
